import {useState} from 'react'
import localForage from "localforage";
import StarboxIcon from '../starboxIcon.svg'
import {useNavigate} from 'react-router-dom'
import icoLightGray from '../img/ico-light-gray.png'
import icoLightGreen from '../img/ico-light-green.png'

import TableCard from '../TableCard';
import SelectingQuotaCard from '../SelectingQuotaCard';
import strings from '../strings.js'
import { SendMessage, socket } from '../App.js';
import home from '../img/home.svg'
import useSongSearch from '../useSongSearch';
//import {artist,heart,hot,newsong,rec,selected,song} from '../img/'

export function Admin({ micEnabled, stateNextSong, stateNextYtname, selectingAll, selectingQuota, selectingCode, selectingMsg, selectingInterval, selectingClear, selectingKey, lang, stateTables, setTableNo, statePlaybackSong, statePlaybackYT, tableNo, stateNextTable}) {
        const [selectingQuotaTable, setSelectingQuotaTable] = useState({});
        const [selectingQuotaNumber, setSelectingQuotaNumber] = useState(0);
        const [selectingQuotaIndex, setSelectingQuotaIndex] = useState(0);
        const navigate = useNavigate()




        const [pageNumber, setPageNumber] = useState(0);
        const {
            loading,
            error,
            songs,
            hasMore
        } = useSongSearch(statePlaybackSong, pageNumber)


        const {
                loading: loadingSecond,
                error: errorSecond,
                songs: songsSecond,
                hasMore: hasMoreSecond,
        } = useSongSearch(stateNextSong, pageNumber)

        const [timer, setTimer] = useState(null);
        const handleStart = () => {
          setTimer(setTimeout(() => {
              localForage.setItem("table", null).then(
                navigate("/tableNo", {replace:true})
              )
          }, 5000));
        };
        const handleEnd = () => {
          clearTimeout(timer);
        };



  return (
        
        <>
                <div className="topCentreIcon"
                        onTouchStart={handleStart}
                        onTouchEnd={handleEnd}
                        onMouseDown={handleStart}
                        onMouseUp={handleEnd}
                >
                        
                        <img style={{paddingBottom: "1vh", paddingTop: "1vh", marginTop:"1.5vh", marginBottom:"1.5vh"}}
                        src={StarboxIcon}
                        alt="Starbox"
                        />
                </div>
                <div className="tableMgmtTop">
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); SendMessage('[{"type":"HALL_PAUSE_CURRENT"}]');
                        }}
                        >       {lang ? strings.cn.playpause : strings.en.playpause}
                                
                        </div>
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); SendMessage('[{"type":"HALL_REPLAY_FORCE"}]');
                        }}
                        >
                                {lang ? strings.cn.replay : strings.en.replay}
                        </div>  
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); SendMessage('[{"type":"HALL_DISCARD_FORCE"}]');}}
                        >
                                {lang ? strings.cn.discard : strings.en.discard}
                        </div>  
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); SendMessage('[{"type":"HALL_STOP_CURRENT"}]');}}
                        >
                                {lang ? strings.cn.next : strings.en.next}
                        </div>
                </div>
                <div className="tableMgmtTop">
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); navigate("code");
                        }}
                        >       {lang ? strings.cn.code : strings.en.code}
                                
                        </div>
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); navigate("msg");  
                        }}
                        >
                                {lang ? strings.cn.msg : strings.en.msg}
                        </div>  
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); navigate("interval");}}
                        >
                                {lang ? strings.cn.interval : strings.en.interval}
                        </div>  
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); navigate("clear");}}
                        >
                                {lang ? strings.cn.clear : strings.en.clear}
                        </div>
                </div>
                <div className="tableMgmtTop">
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault();  SendMessage('[{"type":"YC_VOCAL"}]');
                        }}
                        >       {lang ? strings.cn.ori : strings.en.ori}
                                
                        </div>
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); SendMessage('[{"type":"BC_VOCAL"}]');
                        }}
                        >
                                {lang ? strings.cn.acc : strings.en.acc}
                        </div>  
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault();  SendMessage('[{"type":"DOWN_VOL"}]');}}
                        >
                                {lang ? strings.cn.voldown : strings.en.voldown}
                        </div>  
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); SendMessage('[{"type":"UP_VOL"}]');}}
                        >
                                {lang ? strings.cn.volup : strings.en.volup}
                        </div>
                </div>
                        {micEnabled && 
                <div className="tableMgmtTop">
                        
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); socket.emit("down-mic");
                        }}
                        >
                                {lang ? strings.cn.micdown : strings.en.micdown}
                        </div> 
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); socket.emit("up-mic");
                        }}
                        >       {lang ? strings.cn.micup : strings.en.micup}
                                
                        </div> 
                        
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); socket.emit("down-echo");}}
                        >
                                {lang ? strings.cn.echodown : strings.en.echodown}
                        </div>
                        <div className="tableMgmtNextSong"
                                onClick={(e)=> {e.preventDefault(); socket.emit("up-echo");
                        }}
                        >
                                {lang ? strings.cn.echoup : strings.en.echoup}
                        </div>  
                </div>
        }
        <div  className="tableMgmtNowPlaying">
                <>
                {lang ? strings.cn.playing : strings.en.playing}

                {Object.keys(stateTables).find((key) => stateTables[key].playing) ? (
                        Object.keys(stateTables).find((key) => stateTables[key].playing).toUpperCase()
                ) : ("")}

                {' '}
                </>
                { statePlaybackSong == "1111" ? (
                <>
                {statePlaybackYT.substring(0, 20)}
                </>// - YOUTUBE
                ) : (
                <>
                {songs[0]?.song_name}
                </>// - {songs[0]?.singer} {songs[0]?.singer2 && `, ${songs[0]?.singer2}`} {songs[0]?.singer3 && `, ${songs[0]?.singer3}`}
                )}
        </div >


        <div  className="tableMgmtNowPlaying">
                <>
                
                
                
                </>

                <>
                {lang ? strings.cn.nextsong : strings.en.nextsong}
                {stateNextTable ? "T"+stateNextTable : ""}
                

                {' '}
                </>
                { stateNextSong == "1111" ? (
                <>
                {stateNextYtname.substring(0, 20)}
                </>// - YOUTUBE
                ) : (
                <>
                {songsSecond[0]?.song_name}
                </>// - {songs[0]?.singer} {songs[0]?.singer2 && `, ${songs[0]?.singer2}`} {songs[0]?.singer3 && `, ${songs[0]?.singer3}`}
                )}
                
        </div>






        <div className="tableMgmtContainer">
                {Object.keys(stateTables)?.length > 0
                ? (
                <>
                        {Object.keys(stateTables).map((keyName, index) => {
                        return <TableCard tableName={keyName} table={stateTables[keyName]} lang={lang} key={index} setTableNo={setTableNo} setSelectingQuotaTable={setSelectingQuotaTable} setSelectingQuotaIndex={setSelectingQuotaIndex} setSelectingQuotaNumber={setSelectingQuotaNumber} onClick={() => {}}/>
                        })}     
                </>
                ) :
                (
                <div className="empty">
                        <h2>No songs found</h2>
                </div>
        )}
        </div>



        { selectingQuota && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={1} selectingQuotaTable={selectingQuotaTable} selectingQuotaNumber={selectingQuotaNumber} lang={lang}/>
        </>
        )}


        { selectingCode && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={2} lang={lang} stateTables={stateTables}/>
        </>
        )}

        { selectingMsg && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={3} lang={lang}/>
        </>
        )}

        { selectingInterval && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={4} lang={lang}/>
        </>
        )}

        { selectingClear && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={5} lang={lang}/>
        </>
        )}


        { selectingKey && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={6} lang={lang} selectingQuotaTable={selectingQuotaTable} selectingQuotaIndex={selectingQuotaIndex} selectingQuotaNumber={selectingQuotaNumber} />
        </>
        )}

        { selectingAll && (
        <>
        <SelectingQuotaCard onClick={() => { navigate(-1);}} mode={7} lang={lang} selectingQuotaTable={selectingQuotaTable} stateTables={stateTables}/>
        </>
        )}

        </>
  )
}